<template>
  <div>
    <h5 class="header-stripe">
      <span>{{ $t("FREIGHT AMOUNT") }}</span>
      <div class="action">
        <div v-if="!(isApprovalPending && selectedFreight.amount)">
          <Button type="secondary" size="mini" @click="$emit('closeDrawer')">
            {{ $t("INDENT_CANCEL") }}</Button
          >
          <span v-if="allowSubmit">
            <Button type="primary" size="mini"
              :disabled="disableSubmit"
              @click="updateFreight">
              {{ $t("INDENT_SUBMIT") }}
            </Button>
          </span>
        </div>
        <div v-else-if="isApprovalPending && selectedFreight.amount && checkStatus">
          <Button
            type="secondary"
            size="mini"
            :disabled="!order.user_action"
            @click="rejectPopup"
            >{{ $t("INDENT_REJECT") }}</Button
          >
          <Button
            type="primary"
            size="mini"
            :disabled="!order.user_action"
            @click="approveFreight"
            >{{ $t("INDENT_APPROVE") }}</Button
          >
        </div>
      </div>
      <div>
        <div class="popover-custom no-border with-shadow" v-if="isReject">
          <div
            class="popover-body bg-white"
            :style="{ margin: '-5% 10% 0% 40%' }"
          >
            <div class="flex-container">
              <h3 :style="{ alignItems: 'flex-start' }">
                {{ $t('INDENT_REJECT_BASE_FREIGHT') }}
              </h3>
              <svgicon
                :style="{ alignItems: 'flex-end' }"
                @click="closePopup"
                name="cancelblack"
                width="12"
                height="12"
                :original="true"
              />
            </div>
            <p>
              {{ $t('INDENT_REJECTION_REASON_FREIGHT') }}
            </p>
            <Form :inline="true" class="form-default">
              <FormItem class="mb-0">
                <label style="font-size: smaller; padding-left: 8px;">{{ $t("INDENT_REASON") }}
                <span class="asterisk">*</span>
                </label>
                <Input
                  type="textarea"
                  :rows="1"
                  :placeholder="$t('INDENT_ENTER_REMARKS')"
                  size="mini"
                  v-model="remarks"
                ></Input>
              </FormItem>
            </Form>
            <div class="popover-footer">
              <Button type="text" size="mini" @click="closePopup">
                {{ $t('INDENT_CANCEL') }}
              </Button>
              <Button type="primary" size="mini" @click="rejectFreight">
                {{ $t('INDENT_SUBMIT') }}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </h5>

    <Form :inline="true" class="form-default form-triple mt-15 el-form--inline">
      <div class="form-item-group mb-10">
        <FormItem :label="$t('INDENT_FREIGHT_AMOUNT')" class="mb-0">
          <Input
            type="number"
            maxlength="6"
            :readonly="noEditAble"
            v-model="selectedFreight.amount"
            :placeholder="$t('INDENT_FREIGHT_AMOUNT')"
            class="form-control"
          />
        </FormItem>
        <FormItem :label="$t('INDENT_FREIGHT_TYPE')" class="mb-0">
          <Select
            :disabled="noEditAble"
            v-model="selectedFreight.unit"
            value-key="id"
            filterable
            size="mini"
            @change="onChangeFreight"
            class="select-default"
          >
            <Option
              v-for="item in contractTypes"
              :key="item.id"
              :label="item.name"
              :value="item"
            >
            </Option>
          </Select>
        </FormItem>
        <FormItem :label="$t('INDENT_REASON_FREIGHT_RATE')" class="mb-0" required>
          <Select
            :disabled="noEditAble"
            v-model="selectedFreight.reason"
            value-key="id"
            filterable
            size="mini"
            @change="onChangeFreightAmount"
            class="select-default"
          >
            <Option
              v-for="item in freightAmountReasons"
              :key="item.key"
              :label="item.value"
              :value="item.value"
            >
            </Option>
          </Select>
        </FormItem>
        <FormItem v-if="selectedFreight.reason === 'Others'" required :label="$t('OTHERS')" class="mb-0">
          <Input
            type="textarea"
            :rows="1"
            size="xsmall"
            :readonly="noEditAble"
            v-model="selectedFreight.customReason"
            class="form-control"
            :maxlength="60"
            :minlength="15"
            placeholder="Enter Reason"
            style="margin-bottom:-8px"
          />
        </FormItem>
      </div>
    </Form>
    <div class="popover-inner pb-0">
      <div class="popover-doc">
        <label
          >{{ $t("INDENT_ATTACHMENT") }}
          <span class="asterisk" v-if="baseFreightAttachmentMandatory">*</span>
        </label>
        <Attachments
          :disableUpload="noEditAble"
          :attachments="getFreightAttachments"
          :showPreview="true"
          :disableDelete="true"
          @addAttachments="addAttachments"
        >
        </Attachments>
      </div>
    </div>
    <div class="mt-10 popover-switch" v-if="showRegeneratePaymentToggle">
      <span class="pl-10"> {{ $t("INDENT_REGENERATE_PAYMENT") }} </span>
      <SwitchBtn
        class="ml-5"
        v-model="retriggerPayment"
        active-text="Yes"
        inactive-text="No"
        @change="reTriggerPaymentToggle"
      >
      </SwitchBtn>
    </div>
  </div>
</template>
<script>
import {
  OpenIndentcontractTypes as contractTypes,
  orderStatus,
} from '@/constants/order';
import Attachments from '@common/components/Attachments';
import { mapGetters } from 'vuex';
import { RFQConstants, FleetTypes, movementType } from 'pando-constants';
import { freightAmountReasons } from '@/constants/reason-settings';

export default {
  components: {
    Attachments,
  },
  data() {
    return {
      defaultFreight: null,
      retriggerPayment: false,
      selectedFreight: {
        amount: null,
        unit: null,
        reason: '',
        attachment_ids: [],
        isShipperApproval: false,
        userRejected: false,
        sendForApproval: true,
        customReason: '',
      },
      contractTypes,
      noEditAble: true,
      allowSubmit: false,
      RFQConstants,
      remarks: '',
      orderStatus,
      isReject: false,
      freightAmountReasons,
    };
  },
  props: {
    baseFreight: {
      type: Object,
      default: () => ({}),
    },
    order: {
      type: Object,
      default: () => {},
    },
    baseFreightAttachmentMandatory: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // ...mapGetters({
    //   invoiceDetails: 'order/invoiceDetails',
    // }),
    getFreightAttachments() {
      return this.selectedFreight.attachment_ids;
    },
    showRegeneratePaymentToggle() {
      const ownFleetCheck = this.$hasFeature('no_pay_for_own_fleet') ?
        !(this.order.vehicle.fleet_type === FleetTypes.own) : true;
      return (
        this.$hasFeature('pay_anomaly_settings') &&
        !this.$hasFeature('no_pay') &&
        ownFleetCheck &&
        this.selectedFreight.amount &&
        this.order.status ===
          this.orderStatus.find(status => status.name === 'Delivered').id &&
        !this.baseFreight.freight_charge
      );
    },
    isApprovalPending() {
      const { ApprovalStatus } = this.RFQConstants;
      return (
        this.order.open_freight_charge &&
        this.order.open_freight_charge.approval_status &&
        ![ApprovalStatus.APPROVED, ApprovalStatus.REJECTED].includes(
          this.order.open_freight_charge.approval_status,
        )
      );
    },
    checkStatus() {
      const statusFilter = this.orderStatus.filter(item => item.id === 7 || item.id === 8);
      return !statusFilter.find(status => status.id === this.order.status);
    },
    disableSubmit() {
      return (!this.selectedFreight.reason ||
        (this.selectedFreight.reason === 'Others' && !this.selectedFreight.customReason)) ? true : false;
    },
  },
  async created() {
    // this.$hasPermission('edit_freight_in_approval_pending')
    // will use in future
    // await this.$store.dispatch('order/invoiceDetails', this.order.orderNo);
    // // until invoice is raised edit option should be allowed
    // if (this.invoiceDetails && this.invoiceDetails.invoice && !this.invoiceDetails.invoice.length) {
    if (
      this.$hasPermission('override_freight_charge') &&
      !(
        this.order.status ===
          this.orderStatus.find(status => status.name === 'Delivered').id &&
        this.baseFreight.freight_charge
      )
    ) {
      this.noEditAble = false;
      this.allowSubmit = true;
    }
    // }
    if (this.baseFreight && this.baseFreight.freight_unit) {
      this.setFreight();
    } else {
      this.selectedFreight = {
        amount: null,
        unit: this.contractTypes[0],
        attachment_ids: [],
      };
      // first time usage
      if (
        this.$hasPermission('add_freight_charge') &&
        !(
          this.order.status ===
            this.orderStatus.find(status => status.name === 'Delivered').id &&
          this.baseFreight.freight_charge
        )
      ) {
        this.noEditAble = false;
        this.allowSubmit = true;
      }
    }
    if (
      (!this.$hasPermission('edit_freight_in_approval_pending') &&
      this.order.open_freight_charge && this.order.open_freight_charge.approval_status
       && this.order.open_freight_charge.base_freight &&
      ![
        this.RFQConstants.ApprovalStatus.APPROVED,
        this.RFQConstants.ApprovalStatus.REJECTED,
      ].includes(this.order.open_freight_charge.approval_status)) || !this.order.user_action
    ) {
      this.noEditAble = true;
    }
    await this.getReasonSettings();
  },
  methods: {
    rejectPopup() {
      this.isReject = true;
    },
    closePopup() {
      this.isReject = false;
      this.remarks = '';
      this.freightAmountReasons = [];
    },
    reTriggerPaymentToggle() {
      this.reTriggerPaymentToggle = !this.reTriggerPaymentToggle;
    },
    setFreight() {
      this.selectedFreight.unit = this.contractTypes.find(
        freight => freight.id === this.baseFreight.freight_unit,
      );
      this.selectedFreight.amount = this.baseFreight.freight_charge
        ? this.baseFreight.freight_charge
        : null;
      this.selectedFreight.reason = this.baseFreight.reason || null;
      this.selectedFreight.attachment_ids = this.baseFreight.attachments || [];
    },
    async attachmentCall(file) {
      try {
        const formData = new FormData();
        formData.append('attachment', file.raw);
        const result = await this.$store.dispatch(
          'order/addAttachment',
          formData,
        );
        return result;
      } catch (err) {
        this.$error({ message: this.$getErr('APP_CATCH_ERR') });
      }
    },
    async addAttachments(file) {
      const result = await this.attachmentCall(file);
      if (result && result.error) {
        this.$error({ message: this.$t('INDENT_UPLOAD_FAILED') });
      } else {
        const attachmentObj = {
          id: result.id,
          url: result.attachment_url,
        };
        this.selectedFreight.attachment_ids.push(attachmentObj);
      }
    },
    onChangeFreight(value) {
      this.selectedFreight.unit = value;
    },
    onChangeFreightAmount(value) {
      this.selectedFreight.reason = value;
    },
    async approveFreight() {
      this.selectedFreight.isShipperApproval = true;
      this.selectedFreight.sendForApproval = false;
      await this.updateFreight();
    },
    async rejectFreight() {
      this.selectedFreight.userRejected = true;
      this.selectedFreight.sendForApproval = false;
      await this.updateFreight();
    },
    async updateFreight() {
      if (!Number(this.selectedFreight.amount)) {
        this.$error({
          message: `${this.$t('INDENT_ENTER_FREIGHT_AMOUNT')}`,
        });
      } else {
        try {
          let freightReason = this.selectedFreight.reason;
          if (freightReason === 'Others') {
            freightReason = this.selectedFreight.customReason;
          }
          const payload = {
            freight_amount: this.selectedFreight.amount,
            freight_unit: this.selectedFreight.unit.id,
            reason: freightReason,
            retriggerPayment: this.retriggerPayment,
            attachment_ids:
              this.selectedFreight.attachment_ids &&
              this.selectedFreight.attachment_ids.length
                ? this.selectedFreight.attachment_ids.map(attach => attach.id)
                : [],
            sendForApproval: this.selectedFreight.sendForApproval,
            isShipperApproval: this.selectedFreight.isShipperApproval,
            userRejected: this.selectedFreight.userRejected,
            rejection_remarks: this.remarks,
          };
          if (this.selectedFreight.userRejected) {
            if (!this.remarks.trim()) {
              this.$errorMessage({ message: 'Enter Rejection Reason' });
              return;
            }
          }
          if (this.baseFreightAttachmentMandatory) {
            if (!payload.attachment_ids.length) {
              this.$error({ message: this.$t('INDENT_ATTACHMENT_MANDATORY') });
              return;
            }
          }
          const result = await this.$store.dispatch('order/freightRateUpdate', {
            orderNo: this.order.order_number,
            data: payload,
          });
          if (result.id) {
            if (this.selectedFreight.userRejected) {
              this.$error({ message: result.resMessage });
            } else {
              this.$success({
                message: result.resMessage ||
                  this.$getSuccess('UPDATED_FREIGHT', {
                    firstArgument: this.order.order_number,
                  }),
              });
            }
            this.$emit('closeDrawer', false);
          }
          if (result.error) {
            this.$error({
              message: result.error,
            });
          }
        } catch (error) {
          console.log('file: FreightCharge.vue:393 ~ updateFreight ~ error', error);
          this.$error({ message: this.$getErr('APP_CATCH_ERR') });
        }
      }
    },
    async getReasonSettings() {
      let depotId;
      if (this.order && [movementType.PRIMARY, movementType.SECONDARY].includes(this.order.movement)) {
        depotId = this.order.sources && this.order.sources[0]
          && this.order.sources[0].location_id;
      } else {
        depotId = this.order.destinations && this.order.destinations[0]
          && this.order.destinations[0].location_id;
      }
      const payload = {
        type: 'INDENT_FREIGHT_AMOUNT',
        movement: this.order && this.order.movement,
        depot_id: depotId,
      };
      const result = await this.$store.dispatch('settings/getReasonSettings', payload);
      if (result && result.data && result.data.length) {
        const configReasons = result.data.map(item => ({
          key: item,
          value: item,
        }));
        this.freightAmountReasons = [
          ...this.freightAmountReasons,
          ...configReasons,
        ];
      } else {
        this.freightAmountReasons = [
          ...this.freightAmountReasons,
        ];
      }
      if (!this.freightAmountReasons.find(item => item.key === 'OTHERS')) {
        this.freightAmountReasons.push({
          value: 'Others',
          key: 'OTHERS',
        });
      }
      if (this.selectedFreight.reason &&
        !this.freightAmountReasons.find(item => item.value === this.selectedFreight.reason)) {
        this.selectedFreight.customReason = this.selectedFreight.reason;
        this.selectedFreight.reason = 'Others';
      }
    },
  },
};
</script>
